export type TPlatform = 'web' | 'app';
export enum EEventType {
  click = 'click',
  impression = 'impression',
  modalView = 'modalView',
  hover = 'hover',
  unknown = 'unknown',
}

type IEventType = keyof typeof EEventType;
export interface IEventData {
  params: {
    country: string,
    media: string,
    locale: string,
    page?: string,
    referrer: string,
    url: string,
    source: string,
    [k: string]: any,
    userId?: string,
    subPlanId?: string,
  },
  featureFlags: Record<string, any>,
  platform: string,
  slot: string,
  experiment: string,
  time: number,
  timezoneOffset: number,
  eventType?: IEventType,
}

export type TEffectiveNetworkType = 'slow-2g' | '2g' | '3g' | '4g' | '5g' | 'unknown';

export interface IEventDataV2 {
  eventName: string,
  eventType: IEventType,
  page: {
    url: string,
    path: string,
    name: string,
    params: Record<string, any> | null,
  },
  referrer: {
    url: string | null,
    path: string | null,
    name: string | null,
  },
  deviceId: string,
  deviceTime: number,
  timezoneOffset: number,
  sessionId: string,
  country: string | null,
  userId: string | null,
  subPlanId: string | null,
  locale: string,
  platform: TPlatform,
  screen: {
    width: number,
    height: number,
    density: number,
  },
  featureFlags: Record<string, any>,
  params: Record<string, any> | null,
  effectiveNetworkType: TEffectiveNetworkType,
}

export interface PageView3Params {
  requestCountry: string,
  region: string,
  userId: string,
  locale: string,
  referrer: {
    sourceName: string,
    url: string,
    variant: string,
  },
  screenType: string,
  featureFlags?: Record<string, any>,
}

export interface IUTMParams {
  source: string | null,
  medium: string | null,
  campaign: string,
  name?: string | null,
  term: string,
  content: string,
}

export interface IAnalyticsOptions {
  isProd: boolean,
  areDevEventsAllowed?: boolean,
  platform?: TPlatform,
}

export interface IStorageItem {
  path?: Record<string, any>,
  query?: Record<string, any>,
  fullPath?: string,
}

// TODO (@a4averma): Investigate why the 'Connection' type is not being imported from 'lib.dom.d.ts' and resolve the issue.
export interface IConnection {
  effectiveType?: 'slow-2g' | '2g' | '3g' | '4g' | '5g' | 'unknown',
}

export interface IURLObject {
  fullPath: string,
  hash: string,
  href: string,
  path: string,
  params: Record<string, any>,
  query: Record<string, any>,
  redirectedFrom?: string | undefined,
  matched: any,
  name: string,
}
